import * as React from 'react';
import { SocialMediaService } from '../models';
import { ApiClient } from '../models/Api';

export interface IApiClientContext {
	apiClient: ApiClient;
}

export const ApiClientContext = React.createContext<IApiClientContext>(null);

export const useApiClientContext = () => {
	const context = React.useContext(ApiClientContext);
	if (!context) {
		throw new Error('This component required the use of "ApiClientContext"');
	}
	return context;
};

export const ApiClientContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const context = React.useRef<IApiClientContext>({
		apiClient: new ApiClient({ baseUrl: import.meta.env.VITE_API_URL }),
	}).current;
	return <ApiClientContext.Provider value={context}>{children}</ApiClientContext.Provider>;
};

export interface IServicesContext {
	socialMediaService: SocialMediaService;
}

export const ServicesContext = React.createContext<IServicesContext>(null);
export const useServicesContext = () => {
	const context = React.useContext(ServicesContext);
	if (!context) {
		throw new Error('This component required the use of "ServicesContext"');
	}
	return context;
};

export const ServicesContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const { apiClient } = useApiClientContext();
	const context = React.useRef<IServicesContext>({
		socialMediaService: new SocialMediaService(apiClient),
	}).current;
	return <ServicesContext.Provider value={context}>{children}</ServicesContext.Provider>;
};
